// @ts-nocheck
/* eslint-disable unicorn/no-array-push-push */
import _ from 'lodash-es';
import angular from 'angular';
import Tabulator from 'tabulator-tables';
import Defaults from '~/scripts/constants/defaults';
import Query from '~/scripts/services/model/query';
import QueryRule from '~/scripts/services/model/query-rule';
import QueryColumn from '~/scripts/services/model/query-column';
import { COMPOSED_OF } from '~/scripts/constants/common-kids';
import {
	dateFormatter,
	emailFormatter,
	rowSelectionK,
	stringFormatter,
	urlFormatter,
} from '~/components/kdatatable/formatters';
import { dateSorter, emailSorter, intSorter, stringSorter } from '~/components/kdatatable/sorters';
import { ConfirmDeleteModal } from '~/utils/modals';
import Utils from '~/scripts/services/utils';
import APIV5 from '~/models/api';
import FilterMenuModal from './modals/filter-menu/filter-menu';
import {
	createFileThumb,
	createWorkflowCell,
	rowNumberColumnDefinition,
	rowSelectionColumnDefinition,
} from './columnFactory';
import mfSelectModalComponent from './modals/mf-select/mf-select-modal.component';
import mfMassImportModalComponent from './modals/fast-import/fast-import-modal.component';
import queryFiltersModal from './modals/query-filters/query-filters-modal.component';
import rowDetailsModal from './modals/row-details/row-details-modal.component';
import tableFooter from './ktable-footer.html';
import tableCellDropdown from './ktable-cell-dropdown.html';
import { makeNodeName } from './utils';
import { avg, max, min, notEmpty, sum } from '../kdatatable/operations';

/* globals Knitiv,Ktable */

export const THRESHOLD_NB_CELLS_INSIDE_CELL = 5;

/**
 * @typedef KTableEventParameters
 * @property {boolean} [script=true] Run kform scripts after loading data
 */

Tabulator.prototype.extendModule('format', 'formatters', {
	/**
	 * @param {any} cell
	 * @param {any} formatterParameters
	 * @returns {any} row selection
	 */
	rowSelectionK(cell, formatterParameters) {
		// @ts-ignore
		return rowSelectionK(this.table)(cell, formatterParameters);
	},
});

/** @type {Ktable.Definition} */
export default class KTableController {
	/** @type {any} */
	#oldQuery;

	/* @ngInject */
	/**
	 * @param {import('angular').IRootElementService} $element Angular $element service
	 * @param {import('angular').ICompileService} $compile Angular $compile service
	 * @param {any} $copyToClipboard $copyToClipboard service
	 * @param {import('angular').IFilterService} $filter Angular $filter service
	 * @param {import('angular').auto.IInjectorService} $injector Angular $injector service
	 * @param {import('angular').IQService} $q Angular $q service
	 * @param {Knitiv.RootScope} $rootScope Angular $rootscope service
	 * @param {import('angular').IScope} $scope Angular $scope service
	 * @param {import('angular').ITimeoutService} $timeout Angular $timeout service
	 * @param {import('angular').translate.ITranslateService} $translate Angular $rootscope service
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal Angular $uibModal service
	 * @param {any} FileDownloadService FileDownloadService service
	 * @param {any} NodeService Node service
	 * @param {any} Notification Notification service
	 * @param {any} User
	 */
	constructor(
		$element,
		$compile,
		$copyToClipboard,
		$filter,
		$injector,
		$q,
		$rootScope,
		$scope,
		$timeout,
		$translate,
		$uibModal,
		FileDownloadService,
		NodeService,
		Notification,
		User,
	) {
		this.#oldQuery = undefined;

		this.$compile = $compile;
		this.$copyToClipboard = $copyToClipboard;
		this.$element = $element;
		this.$filter = $filter;
		this.$injector = $injector;
		this.$q = $q;
		this.$rootScope = $rootScope;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.$uibModal = $uibModal;
		this.FileDownloadService = FileDownloadService;
		this.NodeService = NodeService;
		this.Notification = Notification;
		this.User = User;

		/** @type {boolean} */
		this.autoHeight = false;

		/** @type {boolean} */
		this.builder = false;

		/** @type {?{from: number, to: number}} */
		this.card = null;

		/** @type {any[]} */
		this.cols = [];

		/** @type {any} */
		this.component = undefined;

		this.dataTable = {
			/** @type {any} */
			oldColumns: undefined,

			/** @type {?Tabulator} */
			reference: null,

			/** @type {import('tabulator-tables').Options} */
			options: {
				ajaxConfig:             {
					method:  'POST',
					headers: {
						'Content-type': 'application/json; charset=utf-8',
					},
				},
				ajaxLoaderLoading:      '<i class="fa fa-circle-o-notch fa-spin spinner fa-2x"></i>',
				ajaxLoaderError:        '<i class="fa fa-circle-o-notch fa-spin spinner fa-2x"></i>',
				ajaxRequesting:         () => this.ready,
				ajaxRequestFunc:        (url, config, parameters) => this.exec(parameters),
				ajaxSorting:            false,
				ajaxURL:                `${APIV5.instance.backEndpoint}/api/v${Defaults.api.version}/QueryExec`,
				clipboard:              true,
				height:                 undefined,
				layout:                 'fitDataFill',
				layoutColumnsOnNewData: true,
				pageLoaded:             () => {
					if (this.dataTable.reference) {
						this.packet_size = this.dataTable.reference.getPageSize();
					}
				},
				pagination:             'remote',
				paginationButtonCount:  5,
				paginationSizeSelector: [
					50,
					100,
					200,
					500,
				],
				persistenceMode:        'local',
				sortOrderReverse:       true,
			},
		};

		/** @type {Ktable.Options} */
		this.defaultOptions = {
			actions: {
				copy:           true,
				insertCreate:   false,
				insertExisting: false,
				viewCell:       true,
			},
			display: {
				status: true,
			},
		};

		/** @type {any[]} */
		this.descendants = [];

		/** @type {boolean} */
		this.disabled = false;

		/** @type {boolean} */
		this.exporting = false;

		/** @type {{search: any, columns: any}} */
		this.filters = {
			search:  undefined,
			columns: {},
		};
		this.i = 0;
		// eslint-disable-next-line no-undef
		this.isDev = process.env.NODE_ENV !== 'production';

		/** @type {?import('~/components/kform/kform.controller').default} */
		this.kformCtrl = null;

		this.ktableValidate = {};
		this.linkToValues = undefined;
		this.message = undefined;

		/** @type {?import('angular').INgModelController} */
		this.ngModelCtrl = null;

		/** @type {import('~/scripts/services/model/node').default | undefined } */
		this.node = undefined;

		this.oldCols = [];
		this.onBeforeColumnCreate = (/** @type {{column: any}} */ { column }) => Promise.resolve(column);
		this.onDataChanged = (/** @type {{data: any}} */ { data }) => data;

		/**
		 * Émis après chaque chargement de données, seul moment où les lignes
		 * existent — `onReady` l'est sur `tableBuilt`, table encore vide.
		 * @type {Function}
		 */
		this.onDataLoaded = () => {};

		/** @type {Function} */
		this.onReady = () => {};

		/** @type {Ktable.Options} */
		this.options = { ...this.defaultOptions };

		/** @type {number} */
		this.packet_index = 1;

		/** @type {number} */
		this.packet_size = 50;

		/** @type {?import('../kform/tab-form/kform-tab-form.controller').default} */
		this.parentTab = null;

		/** @type {boolean} */
		this.previousLoading = false;

		/** @type {Query | undefined } */
		this.query = undefined;

		/** @type {any} */
		this.queryNode = null;

		/** @type {boolean} */
		this.ready = false;

		/** @type {Tabulator | undefined} */
		this.reference = undefined;

		this.ruleLinkTo = undefined;

		this.search = '';

		this.showFastImport = false;

		/** @type {Ktable.Table} */
		this.table = {
			disabled: false,
			duration: 0,
			loading:  false,
			oldRows:  [],
			total:    0,
			class:    {},
		};

		this.tempKid = undefined;

		/** @type {KTableEventParameters} */
		this.tempOptions = {
			script: true,
		};

		this.values = [];
		this.variables = undefined;
		this.widgetActions = [];
		this.widgetSettings = {
			data: null,
			kid:  '',
		};
	}

	/**
	 * @param {import('@knitiv/api-client-javascript').KNodeOptional} isa
	 * @param {any} file
	 */
	async add(isa, file) {
		const parent = _.merge({}, this.options.parent);
		const formClass = { isa, ktableController: this, file };
		if (parent) {
			parent.target = this.options.target?.class_kid
				? this.options.target
				: {
					class_kid: this.options.parent.isa.objid,
					linker_kid: '0',
					relation_kid: COMPOSED_OF,
				};
			if (this.kformCtrl?.options.readOnly) {
				await this.kformCtrl.edit();
			}
			await this.kformCtrl?.addForm(formClass, parent);
		}
	}

	/**
	 * @param {number} rows The number of rows to estimate
	 * @returns {number} Height in pixels
	 */
	// eslint-disable-next-line class-methods-use-this
	calculateHeight(rows) {
		if (rows > 20) {
			console.error(
				`${rows} is too height. Make sure to specify height in row number and not in pixel.
				Using default value of 5 lines`,
			);
			// eslint-disable-next-line no-param-reassign
			rows = 5;
		}

		let rowSize = 38;
		let headerSize = 38;
		const scrolbarSize = 25;

		if (this.dataTable.reference) {
			const { element } = this.dataTable.reference;

			// @ts-ignore
			const rowHeights = [...element.querySelectorAll('.tabulator-row')].map(element_ => element_.offsetHeight);

			// calculate average of an array of numbers
			rowSize = rowHeights.length > 0 ? (_.sum(rowHeights) / rowHeights.length) : rowSize;

			// @ts-ignore
			headerSize = element.querySelector('.tabulator-header').offsetHeight;
		}

		// height is the number of lines
		// multiplied by 33 which is the height of a cell in tabulator
		// + 35 for the header
		return rowSize * rows + headerSize + scrolbarSize;
	}

	/**
	 * @param {import('tabulator-tables').CellComponent} c
	 * @returns {any[]}
	 */
	contextMenuHandler(c) {
		/** @type {Ktable.RowData} */

		/** @type {any} */
		const data = c.getData();
		const field = c.getField();

		/** @type {import('tabulator-tables').ColumnDefinition['contextMenu']} */
		const menu = [];

		if (this.disabled) {
			menu.push({
				label:  '<i class="fa fa-external-link"></i> Visualiser la ligne',
				action: (_error, cell) => {
					return this.edit(cell.getRow());
				},
			});
		}
		if (this.options?.actions?.update && !this.disabled) {
			menu.push({
				label:  '<i class="fa fa-edit"></i> Éditer la ligne',
				action: (_error, cell) => {
					return this.edit(cell.getRow());
				},
			});
		}

		const makeRowDeltailsLabel = cell => {
			const scope = this.$rootScope.$new(true);

			scope.$ctrl = {
				/**
				 * @param {Event} event
				 */
				viewRowDetailsExternal: event => {
					event.stopPropagation();
					// this.viewRowDetails(cell);
					const root = this.getRoot(cell);

					const { kid } = root;
					window.open(`/form/${kid}`);
				},
			};

			const compiled = this.$compile(
				`<div class="open-external-btn-wraper">
	<span><i class="fa fa-eye"></i> Détails de <b>${data.root.name}</b></span>
	<button
		type="button"
		class="btn btn-sm btn-default open-external-btn"
		ng-click="$ctrl.viewRowDetailsExternal($event)"
	>
		<i class="no-margin fa fa-external-link"></i>
	</button>
</div>`,
			)(scope);
			return compiled.get(0);
		};

		let firstSeparator = false;

		if (this.options.actions.viewCell) {
			menu.push({
				label:  cell => makeRowDeltailsLabel(cell),
				action: (error, cell) => {
					this.viewRowDetails(cell);
				},
			});
			firstSeparator = true;
		}

		if (this.options.actions.copy) {
			menu.push({
				label:  '<i class="fa fa-clipboard"></i> Copier la cellule',
				action: (error, cell) => {
					const output = this.formatterHandler(cell, {}, null, this.$injector, true);
					this.$copyToClipboard(output, true);
				},
			});
			firstSeparator = true;
		}

		// @ts-ignore
		// if (data?.[field]?.cells?.length <= THRESHOLD_NB_CELLS_INSIDE_CELL) {
		// @ts-ignore
		for (const cell of data?.[field]?.cells ?? []) {
			if (cell && cell.kid !== 'NONE' && cell.kid !== data.root.kid) {
				if (firstSeparator) {
					menu.push({ separator: true });
				}
				menu.push({
					label:  () => `<i class="fa fa-eye"></i> Détails de <b>${cell.name}</b>`,
					action: (error, c2) => {
						this.viewCellDetails(c2);
					},
				});
			}
		}
		// }

		if (data?.[field]?.[0]?.file === 1) {
			if (firstSeparator) {
				menu.push({ separator: true });
			}
			menu.push({
				label:  `<i class="fa fa-download"></i> ${this.$translate.instant('common.download')}`,
				action: (error, /** @type {import('tabulator-tables').CellComponent} */ cell) => {
					/** @type {any} */
					const cellData = cell.getData();

					/** @type {string} */
					const cellField = cell.getField();

					return this.download(cellData[cellField]);
				},
			});
		}

		if (this.options?.actions?.delete && !this.disabled) {
			if (firstSeparator) {
				menu.push({ separator: true });
			}
			menu.push({
				label:  '<i class="fa fa-trash"></i> Supprimer la ligne',
				action: (error, cell) => this.delete(cell.getRow()),
			});
		}

		const extras = this.widgetActions ?? [];

		if (extras.length > 0) {
			if (firstSeparator) {
				menu.push({ separator: true });
			}
			menu.push(...extras);
		}

		return menu;
	}

	/**
	 * @param {import('tabulator-tables').RowComponent} row
	 */
	// eslint-disable-next-line consistent-return
	async delete(row) {
		const cells = row.getCells();
		const info = this.getRoot(cells[0]);
		if (info) {
			if (this.values && this.values.length > 0) {
				_.remove(this.values, value => value.kid === info.kid);
			}
			else {
				const modal = new ConfirmDeleteModal(this.$injector);
				const answer = await modal.open(info.name);

				if (answer) {
					if (this.kformCtrl && info.kid in this.kformCtrl.forms && this.kformCtrl.forms[info.kid].create) {
						delete this.kformCtrl.files[info.kid];
						delete this.kformCtrl.forms[info.kid];
						delete this.kformCtrl.submissions[info.kid];
						this.dataTable.reference?.deleteRow(row);
						if (this.component) {
							this.component.table = this.table;
							this.$rootScope.$broadcast('kexecScript', this.kformCtrl.currentClassForm, {
								origin: 'ktable',
								method: 'delete',
								query:  this.query,
							});
						}
					}
					else {
						await this.NodeService.delete(info.kid);
						this.Notification.success({
							title:   this.$translate.instant('object.successfully-deleted-title'),
							message: this.$translate.instant('object.successfully-deleted-message'),
						});
						if (this.component) {
							this.component.table = this.table;
							this.$rootScope.$broadcast('kexecScript', this.kformCtrl?.currentClassForm, {
								origin: 'ktable',
								method: 'delete',
								query:  this.query,
							});
						}
						this.dataTable.reference?.deleteRow(row);
					}
					this.table.total--;
					this.ngModelCtrl?.$validate();
					this.$timeout(() => {
						this.$scope.$apply();
					});
				}
			}
		}
	}

	/**
	 * Download items
	 *
	 * @param {any[]} items
	 * @returns {Promise<void>}
	 */
	async download(items) {
		const result = await this.FileDownloadService.download(items);
		if (result) {
			Utils.download(result.data, result.data.type, result.name);
		}
	}

	/**
	 * @param {Tabulator.RowComponent} row
	 */
	edit(row) {
		const root = this.getRoot(row.getCells()[0]);
		if (this.kformCtrl) {
			this.kformCtrl.openForm(root.kid, _.cloneDeep(this.options.parent));
		}
	}

	/**
	 * @param {any} cell
	 * @param {string | undefined} tab
	 */
	async editCell(cell, tab) {
		if (cell && this.kformCtrl) {
			await this.kformCtrl.openForm(cell.kid, this.options.parent, tab);
		}
	}

	/**
	 * @param {{size: number, page: number}} arg
	 * @returns {Promise<any>} Results
	 */
	async exec({ size, page }) {
		const packetIndex = (page - 1) * size + 1;
		let data = [];

		if (this.packet_index <= 1) {
			this.table.total = 0;
		}

		if (!this.table.loading && this.query) {
			const query = new Query(_.cloneDeep(this.query));

			if (
				query.select.length > 0
				&& query.from.length > 0
			) {
				if (!this.builder && (this.kformCtrl || this.parentTab) && this.options.parent && this.component) {
					if (this.options.parent.kid === 'K_NODE;_new_' && this.kformCtrl?.kid) {
						this.options.parent.kid = this.kformCtrl?.kid;
					}
					query.replaceWhereKid(this.options.parent.kid);
					const form = this.kformCtrl?.forms[this.kformCtrl?.currentClassForm];
					query.setRuleFromFormLinkTo(form, this.component.key);
					this.linkToValues = query.getLinkToValues();
				}

				this.table.loading = true;

				try {
					const queryExecCall = query.version >= '3.0.0' ? 'queryExecV3' : 'queryExec';
					const result /* this.queryNode ?
						await API.instance.queryRun({
							query_kid:    this.queryNode.kid,
							variable:     this.variables,
							packet_index: packetIndex,
							packet_size:  size,
						}, { id: 'ktable.exec' }) : */
						= await APIV5.instance[queryExecCall]({
							query:        query.export(),
							variable:     this.variables,
							packet_index: packetIndex,
							packet_size:  size,
						}, { id: 'ktable.exec' });

					this.packet_index += result.result.packet_size;
					this.table.class = result.result.class;
					this.table.duration = result.result.duration;
					this.table.total = result.result.total;

					data = this.makeData(result.result.rows);

					/** @type {any[]} */
					const temporaryRows = this.makeTemporaryRows();

					// delete temporary rows already existing in base + merge data
					if (temporaryRows.length > 0) {
						for (const [k, row] of result.result.rows.entries()) {
							let index = temporaryRows.length - 1;
							while (index >= 0) {
								// @ts-ignore
								if (row[0][0].row_kid === temporaryRows[index].root) {
									_.merge(result.result.rows[k], temporaryRows[index]);
									temporaryRows.splice(index, 1);
								}
								index -= 1;
							}
						}
						this.table.total += temporaryRows.length;
					}

					// adds temporary rows to data
					for (const temporaryRow of temporaryRows) {
						const firstField = Object.values(temporaryRow).find(tv => tv.length > 0 && tv[0].row_kid);
						if (firstField && firstField.length > 0) {
							const rowKid = firstField[0].row_kid;
							const newRow = {
								// @ts-ignore
								root: this.table.class[rowKid],
							};
							for (const [c, cells] of Object.entries(temporaryRow)) {
								// @ts-ignore
								newRow[c] = {
									cells,
									column: this.query.select.find(select => select.field === c),
								};
							}
							data.push(newRow);
						}
					}

					this.message
						= `${this.$filter('sprintf')(this.$translate.instant('form.ktable-nb-lines'), this.table.total)
						} - ${this.$filter('sprintf')(this.$translate.instant('form.ktable-time-ms'), this.table.duration * 1000)}`;

					this.$timeout(() => {
						this.table.loaded = true;
						this.table.loading = false;
						this.table.disabled = false;
						if (this.component) {
							this.component.table = this.table;
						}
						this.$scope.$apply();
						this.ngModelCtrl?.$validate();
						if (this.kformCtrl) {
							if (this.tempOptions.script) {
								this.$rootScope.$broadcast('kexecScript', this.kformCtrl.currentClassForm, {
									origin: 'ktable',
									method: 'queryExec',
									query,
								});
							}
							else {
								this.tempOptions.script = true;
							}
						}
					});

					return {
						last_page: Math.ceil(this.table.total / size),
						data,
					};
				}
				catch (/** @type {any} */ error) {
					console.error(error);
					this.dataTable.reference?.clearData();
					this.$timeout(() => {
						this.table.loading = false;
						this.table.disabled = false;
						this.message = error.errno_desc;
						this.ngModelCtrl?.$setViewValue(undefined);
					});
				}
			}
		}

		return {
			last_page: 0,
			data,
		};
	}

	async export() {
		const query = new Query(_.cloneDeep(this.query));
		if (this.options.parent) {
			query.replaceWhereKid(this.options.parent.kid);
		}

		this.exporting = true;

		const result = await APIV5.instance.queryExecExportXLSX({
			query,
			export: 'xlsx',
		}, { id: 'ktable.export' });

		this.$timeout(() => {
			this.exporting = false;
		});

		const fileDownloadResult = await this.FileDownloadService.download([{ kid: result.fileid }]);
		if (fileDownloadResult) {
			Utils.download(fileDownloadResult.data, fileDownloadResult.data.type, fileDownloadResult.name);
		}
	}

	filterTable() {
		// eslint-disable-next-line unicorn/consistent-function-scoping
		const matchAny = (/** @type {any} */ data, /** @type {any} */ filterParameters) => {
			let match = false;

			const values = [];

			for (const [key, column] of Object.entries(data)) {
				// If the key is not in this list, add element
				if (!(['id', 'ktable', 'root'].includes(key))) {
					values.push(...column.cells);
				}
			}

			for (const value of values) {
				const name = value?.name?.toString().toLowerCase();

				if (name?.includes(filterParameters.value.toLowerCase())) {
					match = true;
				}
			}

			return match;
		};

		this.filters.search = this.search === '' ? undefined : {
			fn: matchAny,
			params: { value: this.search },
		};

		this.updateFilters();
	}

	/**
	 *
	 * @param {Tabulator.CellComponent} cell
	 * @param {*} parameters
	 * @param {Function | null} onRendered
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {boolean} isTooltip
	 * @returns {string|HTMLElement} HTML Element of the cell content
	 */
	// eslint-disable-next-line class-methods-use-this
	formatterHandler(cell, parameters, onRendered, $injector, isTooltip = false) {
		const settings = parameters?.column?.settings;

		/** @type {Record<string, Ktable.GetFormatterFn>} */
		const formatters = {
			// isa
			'K_NODE;EMAIL': emailFormatter,
			// name_type_kid
			'K_NODE;STRING': stringFormatter,
			'K_NODE;INTEGER': stringFormatter,
			'K_NODE;DATE': dateFormatter,
			'K_NODE;URL': urlFormatter,
			default: stringFormatter,
		};

		/** @type {Ktable.GetFormatterFn} */
		const getFormatter = (
			cellData,
			column,
			cellSettings,
			// eslint-disable-next-line no-shadow
			$injector,
			_isTooltip,
		) => (
			formatters[cellData?.isa]
			?? formatters[cellData?.name_type_kid]
			?? formatters[cellData?.type_kid]
			?? formatters.default
		)(cellData, column, cellSettings, $injector, _isTooltip);

		/** @type {Ktable.CellData} */
		const value = cell.getValue();

		if (!value) {
			return '';
		}

		let div;

		if (value?.cells?.length <= THRESHOLD_NB_CELLS_INSIDE_CELL) {
			const result = value.cells
				.map(value_ => getFormatter(value_, value.column, settings, $injector, isTooltip))
				.map((value_, index, array) => {
					const span = document.createElement('span');
					span.append(value_);

					// usefull in the title to show line breaks
					if (array.length > 1) {
						span.append('\u000D');
					}
					return span;
				});

			div = document.createElement('div');
			div.classList.add('cell-content');

			for (const r of result) {
				div.append(r);
			}
		}
		else {
			const scope = this.$scope.$new();
			// @ts-ignore
			scope.cells = value.cells;
			// @ts-ignore
			scope.$ctrl = this;
			// @ts-ignore
			scope.$tableElement = this.$element.find('.tabulator-tableHolder');

			// scope.action = cell => {
			// 	if (
			// 		this.options.actions.extra.length === 1 &&
			// 		data.cells.length <= THRESHOLD_NB_CELLS_INSIDE_CELL
			// 	) {
			// 		const action = this.options.actions.extra[0]; // 0 is separator
			// 		action.action(event, row);
			// 	}
			// };

			angular.element(cell.getElement()).addClass('bg-gray-400');
			div = this.$compile(tableCellDropdown)(scope)[0];

			if (onRendered && typeof onRendered === 'function') {
				onRendered(() => {
					if (!this.$rootScope.$$phase) {
						scope.$digest();
					}
				});
			}
		}

		if (isTooltip) {
			return div.textContent?.toString() || '';
		}

		return div;
	}

	/**
	 * Get path from query rule
	 *
	 * @returns {Promise<*[]>}
	 */
	async getPath() {
		const path = [];
		const query = new Query(_.cloneDeep(this.query));
		const currentRule = query.findRule((/** @type {QueryRule} */ rule) => rule.value[0].kid === '_KID_');
		if (currentRule instanceof QueryRule) {
			path.push(...Utils.reversePath(currentRule.path).map((/** @type {any} */ p) => {
				if (p.kid === this.options.parent?.isa.objid) {
					p.value = this.options.parent.kid;
				}
				return p;
			}));
		}
		return path;
	}

	/**
	 * @param {Tabulator.CellComponent} cell
	 * @returns {*} root
	 */
	getRoot(cell) {
		/** @type {Ktable.CellData} */
		const value = cell.getValue();

		let rowKid = value?.cells[0]?.row_kid;

		if (!rowKid) {
			rowKid = cell.getRow().getData().root?.kid;
		}

		if (!rowKid) {
			throw new Error('No row_kid available');
		}

		if (!(rowKid in this.table.class)) {
			throw new Error(`"${rowKid}"" not available in "class" hashtable`);
		}
		return this.table.class[rowKid];
	}

	// eslint-disable-next-line class-methods-use-this
	headerMenu() {
		return [
			{
				label: '<i class="fa fa-filter"></i> Filtrer les lignes',
				// eslint-disable-next-line jsdoc/no-undefined-types
				/**
				 * @param {Event} event Event
				 * @param {Tabulator.ColumnComponent} column Column component
				 */
				action: async (event, column) => {
					const field = column.getField();

					/* Get all datas */
					let allData = [];

					const allRows = column.getTable().getRows();
					for (const row of allRows) {
						// @ts-ignore
						allData.push(this.formatterHandler(
							{ getValue: () => row.getCell(field).getValue() },
							{},
							null,
							this.$injector,
							true,
						));
					}

					const allDataActive = this.filters.columns[field] ?? allData;

					// Check element if currently active
					// noinspection JSCheckFunctionSignatures
					allData = _.uniq(allData.sort()).map(x => ({
						name: x,
						checked: allDataActive.includes(x),
					}));

					const modal = new FilterMenuModal(this.$injector);
					const result = await modal.open({
						entries: allData,
					});

					if (Array.isArray(result)) {
						const matches = result.filter(x => x.checked).map(x => x.name);

						this.filters.columns[field] = matches;
						this.updateFilters();
						// @ts-ignore
						await column.updateDefinition({
							titleFormatter: this.titleFormatter.bind(this),
						});
					}
				},
			},
			{
				label: '<i class="fa fa-eraser"></i> Effacer les filtres',
				/**
				 *
				 * @param {*} event Event
				 * @param {Tabulator.ColumnComponent} column Column component
				 */
				action: async (event, column) => {
					const field = column.getField();
					this.filters.columns[field] = undefined;
					this.updateFilters();
					// @ts-ignore
					await column.updateDefinition({
						titleFormatter: this.titleFormatter.bind(this),
					});
				},
			},
		];
	}

	/**
	 * Check if a cell is filtered or not
	 *
	 * Fetch the cell from data and field and compare it with matches
	 *
	 * @param {any} data Passed from Tabulator
	 * @param {{ matches: Array<*>, column: Tabulator.ColumnComponent, field: string }} params Custom params
	 * @returns {boolean} Whether it match or not
	 */
	inArrayFilter(data, { matches, field }) {
		const cell = {
			// Emulate real cell
			getValue: () => data[field],
		};
		if (!matches) {
			return true;
		}
		if (cell) {
			// @ts-ignore
			const value = this.formatterHandler(cell, {}, null, this.$injector);
			return matches.includes(value);
		}
		return false;
	}

	async loadDescendants() {
		let node_kid;
		if (this.query.version >= '3.0.0') {
			node_kid = this.query.where.node.kid;
		}
		else {
			const path = await this.getPath();
			if (path.length > 0) {
				node_kid = path.at(-1).kid;
			}
		}
		/** @type {any[]} */
		this.descendants.length = 0;
		if (node_kid) {
			const resultNode = await APIV5.instance.nodeInfo({
				node_kid,
				get:      {
					descendants: ['down'],
				},
			}, { id: 'mf-insert-node-modal.load-descendants' });
			if (resultNode?.descendants?.down) {
				this.descendants.push(...resultNode.descendants.down);
			}
		}
	}

	/**
	 * @returns {Promise<Tabulator.ColumnDefinition[]>} Returns result
	 */
	async makeColumns() {
		let index = -1;

		const promises = [];

		if (!this.query) {
			return [];
		}

		for (const [k, select] of [...this.query.select].entries()) {
			// eslint-disable-next-line no-loop-func
			promises.push(async () => {
				//                                     is main cell
				if (this.shouldIncludeQuery(select)) {
					index += 1;
				}
				/** @type {Tabulator.ColumnDefinition} */
				let column;
				const field = `f${index}`;

				if (this.query) {
					this.query.select[k].field = field;
				}

				const settings = select?.settings;

				const id = (select?.id ?? index).toString();

				const isFrozen = select?.kdata?.frozen ?? false;

				const calculation = this.options?.widget?.data?.calculation;

				/** @type {Tabulator.ColumnDefinition} */
				const baseOptions = {
					// @ts-ignore
					contextMenu: cell => this.contextMenuHandler(cell),
					field,
					frozen:      isFrozen,
					// sort:        types[select.type] || 'string',
					title:       makeNodeName(select, this.$translate),
					// @ts-ignore
					tooltip:     (cell, parameters) => this.formatterHandler(
						cell, parameters, null, this.$injector, true,
					),
					visible:     !select.hidden,
					width:       select.width || undefined,
				};

				if (settings?.sort?.disabled === true) {
					baseOptions.headerSort = false;
				}
				else {
					baseOptions.headerSortTristate = true;
				}

				if (calculation && Array.isArray(calculation) && calculation.length > 0) {
					const hasCalculation = calculation.find(x => x.column?.toString() === id);

					if (hasCalculation) {
						baseOptions.bottomCalc = (values, data, parameter) => {
							const a = this.operationsHandler(
								hasCalculation, values, data, parameter,
							);

							return a === 0 ? '0' : a;
						};

						baseOptions.bottomCalcFormatter = cell => {
							const d = cell.getValue();

							if (!d) {
								return '';
							}

							const scope = this.$rootScope.$new(true);

							// @ts-ignore
							scope.$ctrl = {
								type: hasCalculation.type,
								data: d.toString(),
							};

							const compiled = this.$compile(`
<div
	uib-tooltip="{{ 'operations.' + $ctrl.type | translate }}"
	tooltip-placement="top"
	tooltip-append-to-body="true"
>
	{{ $ctrl.data }}
</div>
							`)(scope);
							const element = compiled.get(0);
							return element/* ?.outerHTML || '' */;
						};
					}
				}

				// eslint-disable-next-line unicorn/prefer-switch
				if (select?.type === 'rownum') {
					// @ts-ignore
					column = rowNumberColumnDefinition({
						...baseOptions,
					});
				}
				else if (select?.type === 'fileThumb') {
					// @ts-ignore
					column = createFileThumb(cell => this.contextMenuHandler(cell), this.$injector, undefined, {
						...baseOptions,
					});
				}
				else if (select?.type === 'rowSelection') {
					// @ts-ignore
					column = rowSelectionColumnDefinition({
						...baseOptions,
					}, this.$injector);
				}
				else if (select?.type === 'workflow') {
					// @ts-ignore
					column = createWorkflowCell({
						...baseOptions,
					},
					this.$translate,
					this.$scope.$new(true),
					this.$compile,
					(/** @type {Tabulator.CellComponent} */ cell) => {
						/** @type {Ktable.CellData} */
						const value = cell.getValue();
						if (value?.cells && value.cells[0]) {
							return value.cells[0].wf;
						}
						return [];
					});
				}
				// else if ()
				else {
					// @ts-ignore
					column = {
						...baseOptions,
						cellDblClick:         (event, cell) => {
							this.edit(cell.getRow());
						},
						formatter: (
							cell,
							parameters,
							onRendered,
						) => this.formatterHandler(
							cell,
							parameters,
							onRendered,
							this.$injector,
						),
						// @ts-ignore
						formatterParams:      { column: select },
						headerMenu:           this.headerMenu.bind(this),
						sorter:               this.sorterHandler.bind(this),
						titleFormatter:       this.titleFormatter.bind(this),
						titleFormatterParams: {
							// @ts-ignore
							column: select,
							field,
						},
					};
				}

				if (settings?.width) {
					// @ts-ignore
					column.width = settings.width;
				}

				// @ts-ignore
				return this.onBeforeColumnCreate({
					column,
					select,
					// @ts-ignore
					query:  this.query,
				});
			});
		}

		return Promise.all(promises.map(x => x()));
	}

	/**
	 *
	 * @param {Array<Array<Array<any>>>} data Data to transform
	 * @returns {any[]} Rows
	 */
	makeData(data) {
		const rows = [];

		const query = new Query(_.cloneDeep(this.query));

		const queryExport = query.export();

		for (const [rowIndex, row] of data.entries()) {
			/** @type {Ktable.RowData} */
			const newRow = {};

			newRow.ktable = this;
			// @ts-ignore
			newRow.root = this.table.class[row[0][0].row_kid];
			for (const [colIndex, col] of queryExport.select.entries()) {
				newRow[`f${colIndex}`] = {
					cells: row[colIndex],
					column: col,
				};
			}

			newRow.id = rowIndex;
			rows.push(newRow);
		}

		return rows;
	}

	makeTemporaryRows() {
		const temporaryRows = [];
		if (this.kformCtrl && this.query) {
			// check in saved forms if we can generate temporary rows for display purposes
			for (const [formKid, form] of Object.entries(this.kformCtrl.forms)) {
				/** @type {boolean} */
				let insertRow = false;

				/** @type {any} */
				const newRow = {};

				if (form.create) {
					// next we have to check each column to generate cell
					for (const s of this.query.select) {
						let cell;
						const isa = form.isa.objid;

						if (this.shouldIncludeQuery(s)) {
							cell = [{ kid: this.tempKid ?? 'NONE' }];
						}

						// we have to compare form.map elements and query.select
						for (const [key, c] of Object.entries(form.map)) {
							const submissionValue = this.kformCtrl.submissions[formKid]?.data[key];

							// remove incoherent flow in index 0 of path
							if (c?.path && c.path.length > 0 && 'flow' in c.path[0]) {
								delete c.path[0].flow;
							}

							// conditions to add cell:
							// - c.path equals to select.path OR c.kid equals to select.kid
							// - submission value is not empty
							if (
								s.kid
								&& (
									(
										s.path
										&& _.isEqual(
											s.path?.map((/** @type {any} */ v) => ({
												kid: v.kid,
												linker_kid: v.linker_kid,
											})),
											c.path?.map((/** @type {any} */ v) => ({
												kid: v.kid,
												linker_kid: v.linker_kid === null ? '0' : v.linker_kid,
											})),
										)
									)
									|| (!s.path && s.kid === c.kid)
								)
								&& submissionValue !== undefined
							) {
								c.row_kid = formKid;
								insertRow = true;

								switch (c.type) {
								case 'radio': {
									if ('values' in c) {
										let name;

										for (const value of c.values) {
											if (value.value === submissionValue) {
												name = value.label;
											}
										}

										if (name) {
											cell = [
												{
													...c,
													kid: submissionValue,
													name,
													isa,
												},
											];
										}
									}
									break;
								}

								case 'date':
								case 'datetime': {
									cell = [
										{
											...c,
											name: submissionValue,
											isa,
										},
									];
									break;
								}

								case 'smartfield': {
									submissionValue.row_kid = formKid;
									cell = [submissionValue];
									break;
								}

								case 'number': {
									cell = [
										{
											...c,
											name: Number.isNaN(submissionValue) ? undefined : submissionValue,
											isa,
										},
									];
									break;
								}

								case 'password': {
									cell = [
										{
											...c,
											name: '******',
											isa,
										},
									];
									break;
								}

								case 'textfield':
								case 'textarea':
								case 'email':
								case 'phonenumber': {
									cell = [
										{
											...c,
											name: submissionValue.slice(0, 100),
											isa,
										},
									];

									break;
								}

								default: {
									cell = Array.isArray(submissionValue) ? submissionValue.map(subValue => ({
										...subValue,
										row_kid: formKid,
									})) : submissionValue;
								}
								}
							}
						}

						// if select.kid equals to the isa of subform, then we have to get form repre
						if (
							s.kid === form.isa.objid
							&& (!s.path || s.path.length === 1)
							&& this.kformCtrl.submissions[formKid]?.data['KREPRE']
						) {
							const repre = this.kformCtrl.submissions[formKid].data['KREPRE']
								.find(r => r.lang.kid === 'K_NODE;UNIVERSEL');
							cell = [
								{
									create:          form.create,
									name:            repre?.value ?? '',
									kid:             formKid,
									isa:             form.isa.objid,
									type_kid:        form.type_kid,
									file:            0,
									row_kid:         formKid,
									mimetype:        null,
									viewer_mimetype: null,
								},
							];

							if (form.isFile) {
								cell[0].file = 1;
								cell[0].mimetype = this.kformCtrl.files[formKid]?.file?.type;
								cell[0].viewer_mimetype = form.viewer_mimetype;
							}
							insertRow = true;
						}

						if (cell && insertRow) {
							newRow[s.field] = cell;
						}
					}
				}

				if (Object.keys(newRow).length > 0 && insertRow) {
					newRow.root = formKid;
					temporaryRows.push(newRow);
					insertRow = false;
					if (!(newRow.root in this.table.class)) {
						this.table.class[newRow.root] = form;
					}
				}
				// else if (newRow[0][0].kid !== 'NONE') {
				// 	temporaryRows.push(newRow);
				// }
			}
		}

		return temporaryRows;
	}

	openFilters() {
		const modalInstance = this.$uibModal.open({
			...queryFiltersModal({
				resolve: {
					query: () => this.query,
				},
			}),
		});

		modalInstance.result
			.then(() => true)
			.catch(() => {});
	}

	/**
	 * @param {import('@knitiv/api-client-javascript').Calculation} calculation
	 * @param {any[]} values
	 * @param {any[]} data
	 * @param {*} parameter
	 * @returns {string | undefined}
	 */
	operationsHandler(
		calculation,
		values,
		data,
		parameter,
	) {
		/** @type {Record<import('@knitiv/api-client-javascript').Calculation.type | 'default', Ktable.GetOperationFn>} */
		const operation = {
			sum,
			avg,
			notEmpty,
			max,
			min,
			default: () => {
				console.error(`Unknown operation "${calculation.type}"`);
				return '?';
			},
		};

		if (calculation && calculation.type !== null) {
			return (
				calculation.type in operation
					? operation[calculation.type]
					: operation.default
			)(values, data, parameter);
		}
		return undefined;
	}

	async openModalMassImport() {
		if (this.kformCtrl) {
			const form = this.kformCtrl.forms[this.kformCtrl.currentClassForm];

			const executions = await APIV5.instance.rawlist({
				elt_kid: 'KEXECHISTO;0',
				filter: {
					SQL_IN: {
						conf_kid: [this.component.fastImport],
						ref_applicant: [this.$rootScope.context?.profil.kid],
					},
					SQL_NOT_IN: {
						status_kid: [
							'K_NODE;KORDO_STATUS_CANCELED',
							'K_NODE;KORDO_STATUS_END',
						],
					},
				},
			}, {
				id: 'ktable.open-modal-mass-import',
			});

			if (Object.values(executions.elts).length > 0) {
				this.Notification.error({
					title:   this.$translate.instant('error.title'),
					message: 'Un import est déjà en cours',
				})
			}
			else {
				const result = await this.$uibModal.open({
					...mfMassImportModalComponent({
						resolve: {
							fastImport: () => this.component.fastImport,
							form:       () => form,
						},
					}),
				}).result;

				if (result) {
					await this.reload();
				}
			}
		}
	}

	async openModalSelectNode() {
		if (this.kformCtrl) {
			if (this.kformCtrl.options.readOnly) {
				await this.kformCtrl.edit();
			}

			const path = await this.getPath();

			await this.$uibModal.open({
				...mfSelectModalComponent({
					resolve: {
						values: () => this.linkToValues,
						path: () => path,
					},
				}),
			}).result;

			const parent = _.merge({}, this.options.parent);
			if (parent) {
				// TODO type 'K_NODE;STRING' should be filled by other way
				this.kformCtrl.addLinkTo(path, parent, this.component.key, 'K_NODE;STRING');
			}
		}
	}

	onTableReady() {
		this.reference = this.dataTable.reference ?? undefined;

		this.refreshWidgetSettings();

		if (typeof this.onReady === 'function') {
			this.onReady();
		}
	}

	/**
	 * @param {boolean | undefined} redraw
	 */
	redraw(redraw) {
		this.$timeout(() => {
			if (this.dataTable.reference) {
				this.dataTable.reference.redraw(redraw);
			}
		});
	}

	/**
	 */
	refresh() {
		try {
			this.$timeout(() => {
				this.dataTable.reference?.setData(undefined);
				this.table.loading = false;
				this.table.disabled = false;
			});
		}
		catch (error) {
			console.error(error);
			this.table.loading = false;
			this.table.disabled = false;
		}
	}

	refreshWidgetSettings() {
		if (this.options?.widget?.data.sorts.length > 0 && this.reference) {
			/** @type {Tabulator.Sorter[]} */
			const sorts = this.options?.widget?.data?.sorts.map(
				(/** @type {{ type: string; value: string | undefined; }} */ sort) => {
					const direction = sort.type === 'ASC' ? 'asc' : 'desc';

					const col = this.query?.select.find(x => x.id === sort.value);

					if (!col) {
						throw new Error(`Column "${sort.value}" not found`);
					}

					return ({
						column: col.field,
						dir: direction,
					});
				},
			);

			this.reference.setSort(sorts);
		}

		if (this.query && this.options?.widget?.data?.visibility?.length > 0 && this.reference) {
			for (const column of this.query.select) {
				const visibility = this.options?.widget?.data?.visibility.find(
					(/** @type {any} */ col) => col.column === column.id,
				);

				if (!visibility) {
					this.reference.showColumn(column.field);
				}
				else if (visibility.visibility === 'hidden') {
					this.reference.hideColumn(column.field);
				}
				else if (visibility.visibility === 'visible') {
					this.reference.showColumn(column.field);
				}
				else {
					//
				}
			}
		}
	}

	async reload() {
		this.packet_index = 1;
		try {
			await this.dataTable.reference?.setPage(1);
		}
		catch (error) {
			console.error(error);
		}
	}

	/** @deprecated */
	setQuerySelect() {
		if (this.query) {
			this.query.select = [];

			for (const col of this.cols) {
				if (this.shouldIncludeQuery(col) && this.node) {
					/* if (
						this.node.kid === col.kid &&
						this.node.linker_kid === col.linker_kid &&
						this.query.select.length > 0
					) {
						this.query.select[0].hidden = false;
					}
					else { */
					const select = new QueryColumn({
						kid:               col.kid,
						linker_kid:        col.linker_kid,
						linker_info:       undefined,
						hidden:            false,
						name:              col.name,
						path:              [
							{
								kid:  this.node.kid,
								name: this.node.getName(),
								/** @type {?('up'|'down')} */
								flow:       null,
								linker_kid: '0',
							},
						],
						type:              col.type_kid,
					});

					// if (this.node.kid !== col.kid) {
					select.path.push({
						kid:        col.kid,
						name:       col.name,
						flow:       'down',
						linker_kid: col.linker_kid || '0',
					});
					// }

					if (col.linker_kid !== '0') {
						select.linker_info = col.linker_info;
					}

					// @ts-ignore
					this.query.select.push(select);
					/* } */
				}
			}

			if (
				this.node
				&& this.cols.length === 0
				&& this.query.select.length > 0
				&& this.query.select[0].kid === this.node.kid
			) {
				this.query.select[0].hidden = false;
			}
		}
	}

	// eslint-disable-next-line class-methods-use-this
	/**
	 * @param {any} column
	 * @returns {boolean}
	 */
	shouldIncludeQuery(column) {
		return column.includeInQuery === true || !('includeInQuery' in column);
	}

	/**
	 *
	 * @param {Ktable.CellData} a
	 * @param {Ktable.CellData} b
	 * @returns {any}
	 */
	// eslint-disable-next-line class-methods-use-this,no-unused-vars,unicorn/prevent-abbreviations
	sorterHandler(a, b) {
		/** @type {any} */
		const sorters = {
			// isa
			'K_NODE;EMAIL': emailSorter,
			// name_type_kid
			'K_NODE;STRING': stringSorter,
			'K_NODE;INTEGER': intSorter,
			'K_NODE;DOUBLE': intSorter,
			'K_NODE;NUMBER': intSorter,
			'K_NODE;DATE': dateSorter,
			default: stringSorter,
		};

		const type = {
			forceString: a.cells.length > 1,
			isa: a.cells[0].isa,
			type: a.cells[0].name_type_kid,
		};

		// eslint-disable-next-line no-shadow
		const getSorter = (/** @type {any} */ type, /** @type {string} */ a2, /** @type {string} */ b2) => {
			if (type.forceString) {
				return sorters.default(a2, b2);
			}
			return (
				sorters[type.isa] ?? sorters[type.type] ?? sorters.default
			)(a2, b2);
		};

		return getSorter(
			type,
			a.cells.map(value => value.name).join(', '),
			b.cells.map(value => value.name).join(', '),
		);
	}

	/**
	 * @param {Tabulator.CellComponent} cell A cell
	 * @param {any} formatterParams The params
	 * @returns {string} The HTML of the cell
	 */
	// eslint-disable-next-line class-methods-use-this,unicorn/prevent-abbreviations
	titleFormatter(cell, formatterParams = {}) {
		const hasFilter = this.filters.columns[formatterParams.field];
		const name = cell.getValue();
		return `
<span>
		<span>${name}</span>
		${hasFilter ? '<i class="fa fa-filter"></i>' : ''}
</span>
		`;
	}

	updateFilters() {
		// set filter to active elements
		const { reference } = this.dataTable;
		reference?.clearFilter(true);

		// eslint-disable-next-line unicorn/no-array-for-each
		Object.entries(this.filters.columns).forEach(([field, matches]) => {
			// vvv wrong typings from library
			// @ts-ignore
			reference.addFilter(this.inArrayFilter.bind(this), {
				matches,
				field,
			});
		});

		if (this.filters.search) {
			// @ts-ignore
			reference?.addFilter(this.filters.search.fn, this.filters.search.params);
		}
	}

	/**
	 * @param {Tabulator.CellComponent} cell
	 */
	viewRowDetails(cell) {
		const root = this.getRoot(cell);

		const { kid } = root;

		this.$uibModal.open(rowDetailsModal({
			resolve: {
				kid: () => kid,
				locked: () => false,
			},
		}));
	}

	/**
	 *
	 * @param {Tabulator.CellComponent} cell
	 */
	viewCellDetails(cell) {
		/** @type {Ktable.RowData} */
		// @ts-ignore
		const data = cell.getData();
		const field = cell.getField();
		// @ts-ignore
		const { kid } = data[field].cells[0];

		this.$uibModal.open(rowDetailsModal({
			resolve: {
				kid: () => kid,
				locked: () => false,
			},
		}));
	}

	/** @param {import('angular').IOnChangesObject} changes */
	async $onChanges(changes) {
		// @ts-ignore
		if (changes?.widgetSettings) {
			this.refreshWidgetSettings();
		}

		if (changes?.options && changes.options.currentValue) {
			this.options = {
				...this.options,
				...changes.options.currentValue,
			};
		}
	}

	async $doCheck() {
		if (this.query && !this.ready && this.$element.is(':visible')) {
			this.ready = true;
		}

		if (this.kformCtrl) {
			// If loading stopped
			if (this.previousLoading === true && this.kformCtrl.loading === false && this.ready) {
				this.redraw(true);
			}

			// Update loading so we can compare old value
			if (this.previousLoading !== this.kformCtrl.loading) {
				this.previousLoading = this.kformCtrl.loading;
			}
		}

		// Update data-table
		if (this.dataTable.reference) {
			this.reference = this.dataTable.reference;
			// Check query changes
			if (!_.isEqual(this.#oldQuery, this.query)) {
				// clone and also convert to regular object
				this.#oldQuery = _.cloneDeep(this.query);
				const columns = await this.makeColumns();
				// If the columns have changed
				if (
					!_.isEqualWith(
						columns,
						this.dataTable.oldColumns,
						// Skipping formatter as it is a function
						// and it interfere with isEqual (undefined value is handled by isEqual)
						(value1, value2, key) => {
							const blacklist = ['formatterParams', 'formatter', 'sorter', 'contextMenu'];
							// @ts-ignore
							return (blacklist.includes(key) ? true : undefined);
						},
					)
				) {
					this.dataTable.oldColumns = _.cloneDeep(columns);
					this.dataTable.reference.setColumns(columns);
				}
			}

			// if (!_.isEqual(this.table.oldRows, this.table.rows)) {
			// 	const data = this.makeData(this.table.rows);
			// 	this.table.oldRows = _.cloneDeep(this.table.rows);
			//
			// 	// If the data have changed
			// 	if (!_.isEqual(data, this.dataTable.oldData)) {
			// 		this.dataTable.oldData = _.clone(data);
			// 		// Replace data preserve scroll y
			// 		this.dataTable.reference.replaceData(data);
			// 		this.onDataChanged({ data });
			// 		if (!this.autoHeight) {
			// 			this.dataTable.maxHeight = this.calculateHeight(this.table.rows.length);
			// 		}
			// 	}
			// }
		}
	}

	$onInit() {
		this.options = _.merge(
			this.defaultOptions,
			this.options || {},
		);
		// @ts-ignore
		this.dataTable.options = {
			...this.dataTable.options,
			...(this.options?.tableOptions),
		};

		this.dataTable.options.paginationSize = this.options?.widget?.data?.calculation?.length > 0
			? 500
			: this.packet_size;

		this.dataTable.options.footerElement = this.$compile(tableFooter)(this.$scope)[0];

		if (this.component) {
			this.component.table = this.table;
			if (this.component.options.table?.persistentSort && this.options?.parent?.isa?.objid) {
				this.dataTable.options.persistenceID
					= `kt-${this.options.parent.isa.objid.split(';')[1]}-${this.component.key}`;
				this.dataTable.options.persistentSort = true;
			}

			if (this.component.node && this.component.node.length > 0) {
				this.node = this.NodeService.create(this.component.node[0].isa, this.component.node[0].kid);
				this.node?.setName(this.component.node[0].name);

				if (this?.query?.select?.length === 0) {
					// this.setQuerySelect();
				}
			}
		}

		this.card = {
			from: 0,
			to:   Defaults.KCARDN,
		};

		this.packet_index = 1;
		this.packet_size = this.options?.packet_size ?? Defaults.query.packetSize;

		this.showFastImport = this.kformCtrl
			&& !this.kformCtrl.forms[this.kformCtrl.currentClassForm].create
			&& this.options.actions.fastImport;

		this.table = {
			duration: 0,
			oldRows:  [],
			total:    0,
			loaded:   false,
			loading:  false,
			disabled: true,
			class: {},
		};

		if (this.ngModelCtrl) {
			this.ngModelCtrl.$validators.card = () => {
				if (!this.$rootScope.$$phase) {
					this.$scope.$digest();
				}

				const valid = !this.card || this.builder
					|| (this.table.total >= this.card.from && this.table.total <= this.card.to);

				// @ts-ignore
				this.$scope.customError = valid
					? undefined : this.$translate.instant('error.invalid-card-ktable', this.card);

				return valid;
			};
		}

		if (
			this.kformCtrl
			&& this.component?.key
			&& this.kformCtrl.forms
			&& this.options.parent
			&& this.options.parent.kid in this.kformCtrl.forms
		) {
			this.$scope.$on(`ktable-refresh-${this.options.parent.kid}-${this.component.key}`, (
				/** @type {Event} */ event,
				/** @type {KTableEventParameters} */ parameters,
			) => {
				if (parameters?.script === false) {
					this.tempOptions.script = false;
				}
				this.ngModelCtrl?.$setDirty();
				this.refresh();
			});

			this.$scope.$on('ktable-refresh', () => this.refresh());

			this.$scope.$on('Form.ktable-redraw', () => this.redraw(true));
		}

		if (this.ktableValidate && this.ktableValidate.card) {
			const r = /^(\d+|N)-(\d+|N)$/.exec(this.ktableValidate.card);
			if (r) {
				this.card.from = r[1] === 'N' ? Defaults.KCARDN : Number.parseInt(r[1], 10);
				this.card.to = r[2] === 'N' ? Defaults.KCARDN : Number.parseInt(r[2], 10);
			}
		}

		this.dataTable.options.height = this.autoHeight
			? '100%'
			: this.calculateHeight(this.options?.height ?? 5);

		if (this.query?.select && this.query.select.length > 0) {
			this.dataTable.options.initialSort = [];
			for (const select of this.query.select) {
				// @ts-ignore
				if (select.settings?.sort?.default) {
					this.dataTable.options.initialSort.push({
						// @ts-ignore
						column: select.field,
						// @ts-ignore
						dir:    select.settings.sort.default,
					});
				}
			}
		}

		this.$timeout(async () => {
			this.dataTable.options.columns = await this.makeColumns();
			this.descendants.length = 0;

			if (this.options.actions?.insertCreate) {
				if (this.query.from[0].inherits_extended === 0) {
					await this.loadDescendants();
				}
				else {
					this.descendants.push({
						kid:  this.query.from[0].node,
						name: this.query.from[0].name,
					});
				}
			}

			this.$scope.$watch('$ctrl.options.display.status', (newStatus, oldStatus) => {
				if (newStatus !== oldStatus) {
					this.redraw(true);
				}
			});

			if (this.query && !this.table.loading && this.$element.is(':visible')) {
				this.$timeout(() => {
					this.ready = true;
				});
			}
		});
	}
}
